import React, { useCallback } from 'react';

import { Flex } from '~/components/blocks';

import { ContactMethodType } from '../types';
import { ContactMethod } from './ContactMethod';

type Props = {
  hasApp: boolean;
  hasLine: boolean;
  hasSms: boolean;
  selectedMethod?: ContactMethodType;
  onSelect: (contactMethod: ContactMethodType) => void;
};

export const SelectContactMethod = (props: Props) => {
  const { hasApp, hasLine, hasSms, selectedMethod, onSelect } = props;

  const handleClick = useCallback(
    (method: ContactMethodType) => {
      onSelect(method);
    },
    [onSelect],
  );

  return (
    <Flex>
      {hasApp && (
        <ContactMethod
          contactMethod={'APP'}
          onClick={() => handleClick('APP')}
          selected={selectedMethod === 'APP'}
        />
      )}
      {hasLine && (
        <ContactMethod
          contactMethod={'LINE'}
          onClick={() => handleClick('LINE')}
          selected={selectedMethod === 'LINE'}
        />
      )}
      {hasSms && (
        <ContactMethod
          contactMethod={'SMS'}
          onClick={() => handleClick('SMS')}
          selected={selectedMethod === 'SMS'}
        />
      )}
    </Flex>
  );
};
